import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { NomItem } from 'src/app/core/models/core.models';

/** cellRendererParams contract for AgTagsCellRendererComponent. */
export interface AgTagsCellRendererParams {
  /** Row field holding the tag array ({ id, name }[]). */
  field: string;
  /** Property carrying the chip label when it is not `name` (e.g. `title`). */
  nameKey?: string;
}

/**
 * The one grid cell renderer for tag arrays - renders each tag as its own
 * neutral chip (same chrome as the status badges) instead of comma-joined
 * text, so they read as tags. Overflow is clipped; the column tooltip shows
 * the full list. Empty array renders a dash.
 */
@Component({
  selector: 'app-ag-tags-cell-renderer',
  templateUrl: './ag-tags-cell-renderer.component.html',
  styleUrl: './ag-tags-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgTagsCellRendererComponent implements ICellRendererAngularComp {
  tags: NomItem[] = [];

  agInit(params: ICellRendererParams): void {
    this.update(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.update(params);
    return true;
  }

  private update(params: ICellRendererParams): void {
    const { field, nameKey } = params as ICellRendererParams &
      AgTagsCellRendererParams;
    const items = (params.data?.[field] as Record<string, any>[]) ?? [];
    this.tags = nameKey
      ? items.map((item, index) => ({
          id: item['id'] ?? index,
          name: item[nameKey],
        }))
      : (items as NomItem[]);
  }
}
